import { motion } from 'framer-motion'
import type { CSSProperties } from 'react'
import { cn } from '@/utils/cn'

export type WindowPreset = {
  days: number
  label: string
}

type Props = {
  presets: WindowPreset[]
  value: number
  onChange: (days: number) => void
  ariaLabel?: string
}

const thumbTransition = { type: 'spring' as const, stiffness: 420, damping: 34, mass: 0.85 }

export function WindowSegmentPicker({ presets, value, onChange, ariaLabel }: Props) {
  return (
    <div
      className="dashboard-window-slider"
      role="group"
      aria-label={ariaLabel ?? 'Time window presets'}
      style={{ '--window-segments': presets.length } as CSSProperties}
    >
      {presets.map(({ days, label }) => {
        const active = value === days
        return (
          <button
            key={days}
            type="button"
            className={cn('dashboard-window-slider__btn', active && 'dashboard-window-slider__btn--active')}
            onClick={() => onChange(days)}
            aria-pressed={active}
          >
            {active ? (
              <motion.span
                layoutId="dashboard-window-thumb"
                className="dashboard-window-slider__thumb"
                transition={thumbTransition}
              />
            ) : null}
            <span className="dashboard-window-slider__label">{label}</span>
          </button>
        )
      })}
    </div>
  )
}
